import React, { useEffect, useState } from "react";
// import Pusher from "pusher-js";
import {
  Button,
  Card,
  Badge,
  Row,
  Col,
  Avatar,
  message,
  Modal,
  Result,
  Spin,
} from "antd";
import {
  ArrowLeftIcon,
  CouponCart,
  DeleteIcon,
  LocationIcon,
  MoreIcon,
} from "../asset/icons/icons";
import Table from "react-bootstrap/Table";
import EmptyCart from "../asset/EmptyCart.svg";
import opayimg from "../asset/opayimg.png";
import { useDispatch, useSelector } from "react-redux";
import {
  createOpayPayment,
  deleteItemsInCart,
  getAllAvailableLocation,
  getItemsInCart,
  postVerifyTransaction,
  updateItemsInCart,
} from "../redux/Actions";
import { getCartReducer } from "../redux/Reducer/cartReducer";
import { getPaymentReducer } from "../redux/Reducer/paymentReducer";
import ChangeOrderLocationModal from "./changeOrderLocation";
import VerifyAccountModal from "./VerifyAccountModal";
import PayStackButtonMethod from "./paystackButtonMethod";
import SearchableNumberSelect from "./UI/InputFields/SearchableNumberSelect";

const NewCart = ({
  initialCartItems,
  authuserdetails,
  handleVerifyStatus,
  userProfileDetails,
  setSelectedKey,
  onClose,
  setOpen,
  setConfettiActive,
}) => {
  const [modal2Open, setModal2Open] = useState(false);
  const [locationDetails, setLocationDetails] = useState("");
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFlutterModalOpen, setIsFlutterModalOpen] = useState(false);

  const {
    verifyTransaction,
    availableLocations,
    isloadingAvailableLocations,
    isloadingverifyTransaction,
    isloadingUpdatedCartItem,
    isloadingCartItems,
  } = useSelector(getCartReducer);

  const { paymentLoading } = useSelector(getPaymentReducer);
  const dispatch = useDispatch();

  const [cartItems, setCartItems] = useState(initialCartItems || []);
  const [latestUpdatedCartItem, setLatestUpdatedCartItem] = useState({
    id: "",
    qty: "",
  });

  const [subtotal, setSubtotal] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [discountVal, setDiscountVal] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [isOrderButtonDisabled, setIsOrderButtonDisabled] = useState(true);

  // Helper: Format Currency
  const FormatNumber = (number) => {
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
    }).format(number);
  };

  // Helper: Check if Promo is Active based on Date
  const isPromoActive = (product) => {
    if (product?.is_promo_product !== 1) return false;

    const now = new Date();
    const start = product.start_date ? new Date(product.start_date) : null;
    const end = product.end_date ? new Date(product.end_date) : null;

    // Set end date time to end of day
    if (end) end.setHours(23, 59, 59, 999);

    return (!start || now >= start) && (!end || now <= end);
  };

  // Helper: Calculate Price for a specific item (Bundle/Promo Aware)
  const calculateItemPrice = (item) => {
    const product = item?.product;
    if (!product) return 0;

    const qty = Number(item?.qty) || 0;
    const standardTotal = (Number(product?.amount) || 0) * qty;

    // Check Promo Conditions
    if (isPromoActive(product)) {
      // Logic: If it's a promo, the price is based on the Fixed Promo Amount.
      // E.g., if Unit=20, Qty=40, then Price = 2 * PromoAmount.
      const unit = Number(product.unit) || 1;
      const promoAmount = Number(product.promo_amount) || 0;

      // Prevent division by zero
      if (unit > 0) {
        const promoRatio = qty / unit;
        return promoRatio * promoAmount;
      }
    }

    return standardTotal;
  };

  // Helper: Check if item is actively discounted (for UI styling)
  const isItemDiscounted = (item) => {
    const standardTotal =
      (Number(item?.product?.amount) || 0) * (Number(item?.qty) || 0);
    const calculatedTotal = calculateItemPrice(item);
    return calculatedTotal < standardTotal;
  };

  // Main Calculation Function
  const calculateTotals = () => {
    let netTotal = 0;
    let newTotalQuantity = 0;

    (cartItems || []).forEach((item) => {
      const qty = Number(item?.qty) || 0;
      newTotalQuantity += qty;

      // Calculate Net Price (Including Promo logic if active)
      netTotal += calculateItemPrice(item);
    });

    // TEMPORARY: Reset Discount to 0 and make Subtotal = Total
    setSubtotal(netTotal);
    setTotalCost(netTotal);
    setDiscountVal(0);

    setTotalQuantity(newTotalQuantity);

    // Validation Logic
    if (userProfileDetails?.data?.user_type_id !== 5) {
      if (newTotalQuantity < 50) {
        if (cartItems.length > 0) {
          message.warning(
            "You cannot place an order with less than 50 quantity.",
          );
        }
        setIsOrderButtonDisabled(true);
      } else {
        setIsOrderButtonDisabled(false);
      }
    } else {
      setIsOrderButtonDisabled(false);
    }
  };

  const handleQuantityChange = (value, itemId) => {
    const updatedCartItems = cartItems?.map((item) =>
      item?.id === itemId ? { ...item, qty: parseInt(value) || 0 } : item,
    );
    setLatestUpdatedCartItem({
      ...latestUpdatedCartItem,
      id: itemId,
      qty: parseInt(value) || 0,
    });
    dispatch(updateItemsInCart(itemId, { qty: parseInt(value) || 0 }));
    setCartItems(updatedCartItems);
  };

  const handleDeleteItem = (itemId) => {
    const updatedCartItems = cartItems?.filter((item) => item?.id !== itemId);
    dispatch(deleteItemsInCart(itemId));
    setCartItems(updatedCartItems);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setSelectedKey("6");
    setIsModalOpen(false);
    setOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showFlutterModal = () => {
    setIsFlutterModalOpen(true);
    if (latestUpdatedCartItem.id !== "") {
      dispatch(
        updateItemsInCart(latestUpdatedCartItem?.id, {
          qty: parseInt(latestUpdatedCartItem?.qty) || 0,
        }),
      );
    }
  };
  const handleFlutterOk = () => {
    setIsFlutterModalOpen(false);
  };
  const handleFlutterCancel = () => {
    setIsFlutterModalOpen(false);
  };

  const handleChangeLocation = () => {
    setModal2Open(true);
    dispatch(getAllAvailableLocation());
  };

  const handleLocationChange = (locationid, locationname) => {
    setLocationDetails({
      ...locationDetails,
      location_id: locationid,
      location_name: locationname,
    });
    setModal2Open(false);
  };

  const newOpayConfig = {
    platform: "web",
    amount: totalCost,
    location_id:
      userProfileDetails?.data?.location?.id || locationDetails?.location_id,
    is_direct: userProfileDetails?.data?.user_type_id === 5 ? true : false,
    payment_channel: "opay",
  };

  const handlePlaceOrderDist = (value) => {
    dispatch(
      postVerifyTransaction({
        reference: `NB${Date.now()}`,
        transaction_id:
          Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000,
        location_id:
          locationDetails === ""
            ? userProfileDetails?.data?.location?.id
            : locationDetails?.location_id,
        is_direct: userProfileDetails?.data?.user_type_id === 5 ? true : false,
      }),
    );
    if (latestUpdatedCartItem.id !== "") {
      dispatch(
        updateItemsInCart(latestUpdatedCartItem?.id, {
          qty: parseInt(latestUpdatedCartItem?.qty) || 0,
        }),
      );
    }
    setIsLoadingPayment(true);
  };

  const handleOpayPayment = (value) => {
    setIsLoadingPayment(paymentLoading);
    if (latestUpdatedCartItem.id !== "") {
      dispatch(
        updateItemsInCart(latestUpdatedCartItem?.id, {
          qty: parseInt(latestUpdatedCartItem?.qty) || 0,
        }),
      );
    }
    dispatch(createOpayPayment(newOpayConfig));
  };

  useEffect(() => {
    setCartItems(initialCartItems ?? []);
  }, [initialCartItems]);

  useEffect(() => {
    if (cartItems && cartItems.length > 0) {
      calculateTotals();
    } else {
      setSubtotal(0);
      setDiscountVal(0);
      setTotalCost(0);
      setTotalQuantity(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItems]);

  useEffect(() => {
    if (verifyTransaction?.status === true) {
      dispatch(getItemsInCart(authuserdetails.id));
      onClose();
      setConfettiActive(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyTransaction]);

  return (
    <Card>
      <div className="dashboardcardpriceandcartdiv">
        <p
          className="typography"
          style={{ fontSize: "18px", fontWeight: "500", color: "#1A202C" }}
        >
          My Cart
        </p>
        <Button
          type="text"
          style={{ margin: "-1.5em 0px 0px 0px", padding: "0px" }}
        >
          <MoreIcon />
        </Button>
      </div>

      <Spin spinning={isloadingCartItems} tip="Loading Cart">
        {cartItems?.code !== "ERR_BAD_REQUEST" ? (
          cartItems?.length !== 0 ? (
            <div className="">
              <Badge size="small" count={cartItems?.length} color="#BDC167">
                <p
                  className="typography"
                  style={{
                    color: "#252A4D",
                    fontWeight: 500,
                    fontSize: "16px",
                  }}
                >
                  Orders
                </p>
              </Badge>
              <Row>
                <Col span={24}>
                  <Table responsive borderless size="sm">
                    <thead>
                      <tr>
                        <th className="cart-table-header-style">Item</th>
                        <th className="cart-table-header-style">Qty</th>
                        <th className="cart-table-header-style">Price</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItems?.length !== 0 ? (
                        cartItems?.map((item, i) => {
                          const isDiscounted = isItemDiscounted(item);
                          const isPromo = isPromoActive(item?.product);

                          return (
                            <tr key={item.id}>
                              <td>
                                <div className="d-flex align-items-center gap-1">
                                  <div>
                                    <Avatar
                                      size="medium"
                                      icon={
                                        <img
                                          src={item?.product?.images[0]?.url}
                                          alt="carticonimage1"
                                          draggable={false}
                                        />
                                      }
                                    />
                                  </div>
                                  <div>
                                    <p className="typography carttextproductnametypography">
                                      {item?.product?.name}
                                      {isDiscounted && (
                                        <span
                                          style={{
                                            fontSize: "10px",
                                            color: "#BDC167",
                                            marginLeft: "5px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          (Promo Deal)
                                        </span>
                                      )}
                                    </p>
                                    <p className="typography carttextproductpricetypography">
                                      {/* Only show Unit price if NOT a fixed bundle/promo deal */}
                                      {!isDiscounted &&
                                        FormatNumber(item?.product?.amount)}
                                    </p>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <SearchableNumberSelect
                                    value={item?.qty}
                                    onChange={(val) =>
                                      handleQuantityChange(val, item?.id)
                                    }
                                    allowClear={!isPromo}
                                    disabled={isPromo} // LOCK QTY IF PROMO
                                  />
                                  {/* {isPromo && (
                                    <span
                                      style={{
                                        fontSize: "10px",
                                        color: "#D4AF37",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Promo
                                    </span>
                                  )} */}
                                </div>
                              </td>
                              <td>
                                <div className="dashboardcardpriceandcartdiv">
                                  <p
                                    className="typography carttextproductQpricetypography"
                                    style={{
                                      color: isDiscounted
                                        ? "#D4AF37"
                                        : "inherit",
                                      fontWeight: isDiscounted
                                        ? "bold"
                                        : "normal",
                                    }}
                                  >
                                    {FormatNumber(calculateItemPrice(item))}
                                  </p>
                                </div>
                              </td>
                              <td>
                                <div className="dashboardcardpriceandcartdiv">
                                  <Button
                                    type="text"
                                    style={{
                                      margin: "0px",
                                      padding: "0px",
                                      height: "fit-content",
                                    }}
                                    onClick={() => handleDeleteItem(item?.id)}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : cartItems?.code === "ERR_BAD_REQUEST" ? (
                        <tr>
                          <td colSpan="4">
                            <p>No item in cart</p>
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </Table>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <div>
                    <p
                      className="typography"
                      style={{ fontWeight: 500, marginTop: "10px" }}
                    >
                      Nearest Pickup to you
                    </p>
                  </div>

                  <div className="dashboardcardpriceandcartdiv">
                    {locationDetails === "" ? (
                      <p className="cartnearestlocation">
                        <LocationIcon />
                        {`${userProfileDetails?.data?.location?.name} - ${userProfileDetails?.data?.location?.address}`}
                      </p>
                    ) : (
                      <p className="cartnearestlocation">
                        <LocationIcon />
                        {`${locationDetails?.location_name}`}
                      </p>
                    )}
                    <Button
                      size="small"
                      className="cartnearestlocationbutton"
                      onClick={handleChangeLocation}
                    >
                      Change
                    </Button>
                    <ChangeOrderLocationModal
                      modal2Open={modal2Open}
                      setModal2Open={setModal2Open}
                      availableLocations={availableLocations}
                      isloadingAvailableLocations={isloadingAvailableLocations}
                      handleLocationChange={handleLocationChange}
                      defaultsel={
                        locationDetails === ""
                          ? userProfileDetails?.data?.location?.id
                          : locationDetails?.location_id
                      }
                    />
                  </div>

                  <div>
                    <p className="typography cartpickingwhenready">
                      You will be picking up your order from this location once
                      it is ready.
                    </p>
                  </div>

                  <div style={{ marginTop: "2em" }}>
                    {/* Discount Section */}
                    <div
                      className="cartpricesummariesdiv"
                      style={{ color: discountVal > 0 ? "#BDC167" : "inherit" }}
                    >
                      <p className="cartpricesummariestypog1">
                        Discount {discountVal > 0 && "(Promo Applied)"}
                      </p>
                      <p className="typography">
                        {discountVal > 0
                          ? `- ${FormatNumber(discountVal)}`
                          : "₦0"}
                      </p>
                    </div>

                    <div className="cartpricesummariesdiv">
                      <p className="cartpricesummariestypog1">Sub total</p>
                      <p className="typography">{FormatNumber(subtotal)}</p>
                    </div>

                    <div className="cartpricesummariesdiv">
                      <p className="cartpricesummariestypog1 cartprices-total-txt">
                        Total
                      </p>
                      <p className="typography cartprices-total-txt">
                        {FormatNumber(totalCost)}
                      </p>
                    </div>

                    {userProfileDetails?.data?.user_type_id === 5 ? (
                      <div className="mt-2">
                        <Button
                          block
                          size={"large"}
                          className="placeordercartbutton typography"
                          onClick={handlePlaceOrderDist}
                          disabled={
                            isLoadingPayment || isloadingverifyTransaction
                          }
                        >
                          Place Order
                        </Button>
                      </div>
                    ) : userProfileDetails?.data?.status === 1 ? (
                      <div>
                        <div className="cartpricesummariesdiv">
                          <Button
                            block
                            size={"large"}
                            className="cartcouponbutton typography"
                          >
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <div className="d-flex align-items-center gap-2">
                                <CouponCart
                                  style={{ backgroundColor: "#BDC167" }}
                                />
                                <div>
                                  <span style={{ marginLeft: "1em" }}>
                                    Have a coupon code?
                                  </span>
                                </div>
                              </div>
                              <div className="">
                                <ArrowLeftIcon />
                              </div>
                            </div>
                          </Button>
                        </div>

                        <div className="mt-2">
                          <Button
                            block
                            size={"large"}
                            className="placeordercartbutton typography"
                            onClick={handleOpayPayment}
                            disabled={
                              isOrderButtonDisabled ||
                              isLoadingPayment ||
                              isloadingUpdatedCartItem
                            }
                            icon={
                              <img
                                src={opayimg}
                                alt="Opay"
                                style={{ height: "2.7em" }}
                              />
                            }
                          >
                            Pay with Opay
                          </Button>
                        </div>

                        <div>
                          <PayStackButtonMethod
                            userProfileDetails={userProfileDetails}
                            setIsLoadingPayment={setIsLoadingPayment}
                            isLoadingPayment={isLoadingPayment}
                            isloadingUpdatedCartItem={isloadingUpdatedCartItem}
                            showModal={showModal}
                            authuserdetails={authuserdetails}
                            totalCost={totalCost}
                            isOrderButtonDisabled={isOrderButtonDisabled}
                            postVerifyTransaction={postVerifyTransaction}
                            dispatch={dispatch}
                            latestUpdatedCartItem={latestUpdatedCartItem}
                            locationDetails={
                              locationDetails === ""
                                ? userProfileDetails?.data?.location?.id
                                : locationDetails?.location_id
                            }
                          />
                        </div>
                        <div className="cartpricesummariesplaceorderdiv">
                          <Button
                            block
                            size={"large"}
                            className="placeordercartbutton typography"
                            onClick={showFlutterModal}
                            disabled={
                              isOrderButtonDisabled ||
                              isLoadingPayment ||
                              isloadingUpdatedCartItem
                            }
                            icon={
                              <img
                                src={
                                  "https://logosmarcas.net/wp-content/uploads/2022/06/Flutterwave-Simbolo.png"
                                }
                                alt="Paystack"
                                style={{ height: "1.7em" }}
                              />
                            }
                          >
                            Pay with FlutterWave
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <Button
                        block
                        size={"large"}
                        onClick={showModal}
                        style={{ fontSize: "13px", fontWeight: 400 }}
                        className="placeordercartbutton typography"
                      >
                        Verify your account to proceed with payment
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            <img
              src={EmptyCart}
              alt="no order history"
              style={{ width: "100%" }}
              draggable={false}
            />
          )
        ) : (
          <img
            src={EmptyCart}
            alt="no order history"
            style={{ width: "100%" }}
            draggable={false}
          />
        )}
        <VerifyAccountModal
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
        />
        <Modal
          title=""
          open={isFlutterModalOpen}
          onOk={handleFlutterOk}
          onCancel={handleFlutterCancel}
          footer={[
            <Button type="primary" onClick={handleFlutterOk}>
              OK
            </Button>,
          ]}
        >
          <Result
            status="warning"
            title="Service Currently Not Available, Kindly use another payment option."
          />
        </Modal>
      </Spin>
    </Card>
  );
};
export default NewCart;
